const OrgChartNode = (node) => {
	const isHighlighted = node.data._highlighted;

	return `
    <div style="
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 16px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      background: ${isHighlighted ? "#ffe9e9" : "#ffffff"};
      border: 2px solid ${isHighlighted ? "#e11244" : "#00447b"};
      border-radius: 8px;
      font-family: Arial, sans-serif;
      overflow: hidden;
    ">
      <div style="
        flex-shrink: 0;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        background-color: #f0f0f0;
        border: 2px solid #00447b;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;
      ">
        <svg width="32" height="32" fill="#00447b" viewBox="0 0 24 24">
          <path d="M12 12c2.7 0 4.5-1.8 4.5-4.5S14.7 3 12 3 7.5 4.8 7.5 7.5 9.3 12 12 12Zm0 1.5c-3 0-9 1.5-9 4.5V21h18v-3c0-3-6-4.5-9-4.5Z"/>
        </svg>
      </div>

      <div style="
        flex: 1;
        width: 100%;
        text-align: center;
        overflow-y: auto;
        max-height: calc(100% - 62px);
      ">
        <div style="
          font-size: 14px;
          font-weight: bold;
          color: #00447b;
          margin-bottom: 8px;
          word-break: break-word;
        ">
          ${node.data.name}
        </div>

        <div style="
          font-size: 12px;
          color: #e11244;
          margin-bottom: 8px;
          font-weight: 500;
          word-break: break-word;
        ">
          ${node.data.position}
        </div>

        <div style="
          font-size: 11px;
          color: #000000;
          margin-bottom: 4px;
          word-break: break-word;
        ">
          ${node.data.email || ""}
        </div>
      </div>
    </div>
  `;
};

export default OrgChartNode;
